<template>
    <div class="heightSource">
      <height-sources-container></height-sources-container>
    </div>
</template>
<script>
import HeightSourcesContainer from '@/components/senior/Container.vue'

export default {
  name: 'heightsources',
  components: {
    HeightSourcesContainer
  }
}
</script>
<style lang="stylus">
.heightSource
  height 100%
  overflow hidden
</style>
